export default "__VITE_ASSET__DnRiNxUH__"